import { render } from "./TopicSegment.vue?vue&type=template&id=68f4acef&scoped=true"
import script from "./TopicSegment.vue?vue&type=script&lang=js"
export * from "./TopicSegment.vue?vue&type=script&lang=js"

import "./TopicSegment.vue?vue&type=style&index=0&id=68f4acef&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68f4acef"]])

export default __exports__